import React from "react";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import PostItem from "./PostItem";
import postViewsActions from "../../../model/post_views/actions";
import { getSearchPosts } from "../../../model/posts/selectors";

class Search extends React.Component {
  render() {
    const { posts, updatePostView } = this.props;
    return (
      <Grid container>
        {posts.map(post => {
          return (
            <PostItem key={post.id} post={post} onClick={updatePostView} />
          );
        })}
      </Grid>
    );
  }
}

Search.propTypes = {
  posts: PropTypes.arrayOf(Object).isRequired,
  updatePostView: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  posts: getSearchPosts(state),
});

const mapDispatchToProps = dispatch => ({
  updatePostView: id => dispatch(postViewsActions.create(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Search);
